export default __webpack_public_path__ + "static/media/azul_seguro_assinaturas.e3a58060.png";